import { useCallback, useState } from 'react';

import { useSnackbar } from 'notistack';

import { useCognito } from 'src/aws/Cognito';
import { SNACKBAR } from 'src/utils/constants/app';

import { USER_POOL_ID } from '../constants';

import { useIdentityService } from './useIdentityService';

interface UseConfirmUserResult {
  inProgress: boolean;
  confirmUser: (username: string) => void;
}

export const useConfirmUser = (): UseConfirmUserResult => {
  const { identityService } = useIdentityService();
  const { isAdmin } = useCognito();
  const { enqueueSnackbar } = useSnackbar();

  const [inProgress, setInProgress] = useState(false);

  const confirmUser = useCallback(
    (username) => {
      if (identityService && isAdmin) {
        setInProgress(true);

        identityService.adminConfirmSignUp(
          {
            UserPoolId: USER_POOL_ID as string,
            Username: username,
          },
          (error) => {
            if (error) {
              enqueueSnackbar(`User confirmation failed. ${error.message}`, {
                ...SNACKBAR.defaultOptions,
                variant: 'error',
                persist: false,
                resumeHideDuration: SNACKBAR.resumeHideDuration.error,
              });

              throw new Error(error.message);
            }

            setInProgress(false);
          }
        );
      }
    },
    [identityService, isAdmin, enqueueSnackbar]
  );

  return { inProgress, confirmUser };
};
